import {Form, message, Transfer, Modal, Popconfirm, Button} from 'antd';
import React, {PureComponent} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {modal} from 'icsoc-antd-ex';
import newRoleActions from 'Actions/systemSetting/newRole';

const {ModalSize} = modal;

class NewRole extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      mockData: [],
      targetKeys: [],
      saveTargetKeys: [],
      editLoading: false,
      targetKeysBoolen: true,
    };
  }

  componentDidMount() {
    this.getMock();
  }

  getMock = () => {
    const {addUserData} = this.props;
    const userSelect = [];
    const userUnSelect = [];
    if (addUserData.userSelect && addUserData.userSelect.length !== 0) {
      addUserData.userSelect.map(item => {
        const val = {
          key: item.id,
          title: item.name,
          description: `description of ${item.name}`,
        };
        userUnSelect.push(val);
        userSelect.push(val.key);
        return item;
      });
    }
    if (addUserData.userUnSelect && addUserData.userUnSelect.length !== 0) {
      addUserData.userUnSelect.map(item => {
        userUnSelect.push({
          key: item.id,
          title: item.name,
          description: `description of ${item.name}`,
        });
        return item;
      });
    }
    this.setState({
      mockData: userUnSelect || [],
      targetKeys: userSelect || [],
      saveTargetKeys: userSelect || [],
    });
  };

  filterOption = (inputValue, option) =>
    option.description.indexOf(inputValue) > -1;

  handleChange = targetKeys => {
    this.setState({targetKeys}, ()=>{
      const {targetKeys, saveTargetKeys} = this.state;
      let boolen = true;
      if(saveTargetKeys.length === targetKeys.length){
        if(saveTargetKeys.length !==0){
          saveTargetKeys.map(item=>{
            if(targetKeys.indexOf(item) === -1){
              boolen = false
              return false
            }
            return true
          })
        }
      }else{
        boolen = false
      }
        this.setState({
          targetKeysBoolen: boolen, 
        })
    });
    

  };

  handleSearch = (dir, value) => {
  };

  handleSubmit = () => {
    const {
      setAddUserVisible,
      actions,
      addUserData,
      getTableList,
      pageStatus,
      searchData = {name: ''},
    } = this.props;
    const {targetKeys} = this.state;
    const that = this

        if (targetKeys.length !== 0) {
          const params = {
            roleId: addUserData.id,
            userIds: targetKeys,
          };

          that.setState({
            editLoading: true,
          });
          actions
            .setUserBinding(params)
            .then(res => {
              const {payload: {code} = {}} = res || {};
              if (parseInt(code, 10) === 200) {
                message.success('操作成功！');
                getTableList({...pageStatus, ...searchData});
              }
            })
            .finally(() => {
              that.setState({
                editLoading: false,
              });
            });
        }
        setAddUserVisible();
  };

  render() {
    const {setAddUserVisible} = this.props;
    const {mockData, targetKeys, targetKeysBoolen, editLoading} = this.state;
    return (
      <ModalSize
        width={800}
        title="添加用户"
        centered
        maskClosable={false}
        visible
        // onOk={this.handleSubmit}
        onCancel={setAddUserVisible}
        editLoading={editLoading}
        footer={[
          <Button onClick={setAddUserVisible}>取消</Button>,
          <Popconfirm
            // className='addUserPop'
            disabled={targetKeysBoolen}
            title="批量添加用户到角色会清除
            用户原有的角色属性，确定进行操作么？"
            onConfirm={this.handleSubmit}
            onCancel={this.cancel}
            okText="确认"
            cancelText="取消"
          >
            <Button 
              style={{marginLeft:10}}
              disabled={targetKeysBoolen}
              key="submit" 
              type="primary">
            确认
            </Button>
          </Popconfirm>, ]}
         
        >
        {mockData.length !== 0 ? (
          <Transfer
            className="addUserTransfer"
            dataSource={mockData}
            showSearch
            filterOption={this.filterOption}
            targetKeys={targetKeys}
            onChange={this.handleChange}
            onSearch={this.handleSearch}
            render={item => item.title}
            listStyle={{width: '47%', height: 500}}
            titles={['待添加的用户', '已添加的用户']}
          />
        ) : null}
        
      </ModalSize>
    );
  }
}

const mapStateToProps = ({systemSettingNewRole}) => ({
  newRoleData: systemSettingNewRole.newRoleData,
  pageStatus: systemSettingNewRole.pageStatus,
  addUserData: systemSettingNewRole.addUserData,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(newRoleActions, dispatch),
});

const NewRoleWrap = Form.create()(NewRole);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NewRoleWrap);
